import { render, staticRenderFns } from "./TftStartButton.vue?vue&type=template&id=4ec13ebc"
import script from "./TftStartButton.vue?vue&type=script&lang=js"
export * from "./TftStartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports